var map = {
	"./charactor1": 260,
	"./charactor1.png": 260,
	"./charactor2": 261,
	"./charactor2.png": 261,
	"./employment_insurance_number": 262,
	"./employment_insurance_number.png": 262,
	"./favicon": 263,
	"./favicon.png": 263,
	"./logo": 264,
	"./logo-old": 265,
	"./logo-old.png": 265,
	"./logo.png": 264,
	"./middle-image": 266,
	"./middle-image.png": 266,
	"./middle-image2": 267,
	"./middle-image2.png": 267,
	"./pension_mark": 268,
	"./pension_mark.png": 268,
	"./pension_number": 269,
	"./pension_number.png": 269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;